import { Select } from 'antd';
import type { SelectProps } from 'antd';
import type { BaseOptionType, DefaultOptionType } from 'rc-select/lib/Select';
import styled from 'styled-components';

const StyledSelect = styled(Select)`
  width: 330px;
  text-align: left;

  .ant-select-arrow {
    color: ${({ theme }) => theme.color.grey35};
  }
`;

export const SSelect = StyledSelect as <
  ValueType = unknown,
  OptionType extends BaseOptionType | DefaultOptionType = DefaultOptionType
>(
  props: SelectProps<ValueType, OptionType>,
) => JSX.Element;
